import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EcashDescriptionComponent } from './ecash-description.component';
import { CarouselModule } from 'ngx-owl-carousel-o';
import { FGBSharedModule } from '@fgb/portal-component-library/src/lib/shared';

@NgModule({
  declarations: [EcashDescriptionComponent],
  imports: [
    CommonModule,
    CarouselModule,
    FGBSharedModule
  ],
  exports: [EcashDescriptionComponent],
})
export class EcashDescriptionModule {}
